import React, { createContext, useState, useEffect } from "react";
import { getUser } from "../services/UserProfileApi";
import { getImageUrlWithToken } from "../utils/ImageUtils";
import { trackGTMEvent } from "../utils/gtmTracking";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isFetching, setIsFetching] = useState(true);



  console.log("user", user);

  // Function to fetch user data
  const fetchUser = () => {
    setIsFetching(true);
    getUser() 
      .then((data) => {

        setUser(data.user);
        

        if (data.user.thumbnail_pic) {
          setUser((prev) => ({
            ...prev,
            thumbnail_pic: getImageUrlWithToken(data.user.thumbnail_pic),
          }));
        }
        if (data.user.profile_pic) {
          setUser((prev) => ({
            ...prev,
            profile_pic: getImageUrlWithToken(data.user.profile_pic),
          }));
        }

        // Track social login success in GTM if this was triggered by social login
        const isSocialLogin = sessionStorage.getItem("social_login_in_progress");
        if (isSocialLogin === "true" && data.user) {
          trackGTMEvent("social_login_success", {
            userId: data.user.id,
            accountType: data.user.account_type,
            emailVerified: data.user.email_verified,
          });
          // Clear the flag after tracking
          sessionStorage.removeItem("social_login_in_progress");
        }
      })
      .catch((error) => console.error("Error fetching user", error))
      .finally(() => setIsFetching(false));
  };

  // Fetch user on component mount
  useEffect(() => {
    fetchUser();
  }, []);

  return (
    <UserContext.Provider
      value={{
        user,
        isFetching,
        refreshUser: fetchUser, // Expose the refreshUser function
        setUser, // Expose the setUser function
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
